// assets/featured-collection-blog.js
(function () {
  function moneyFormatter() {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: cur
    });
  }

  function withWidth(url, w) {
    if (!url) return "";
    const hasQuery = url.includes("?");
    return `${url}${hasQuery ? "&" : "?"}width=${w}`;
  }

  function buildStylesOnce() {
    const id = "fc2-style";
    if (document.getElementById(id)) return;

    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      .fc2 {
        --gap: 1rem;
        margin: 1.25rem 0;
        isolation: isolate;
      }

      .fc2__header {
        text-align: center;
        margin-bottom: 1rem;
      }

      .fc2__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: var(--gap);
      }

      @media (min-width:700px) {
        .fc2__grid {
          grid-template-columns: repeat(4, minmax(0, 1fr));
        }
      }

      /* neutrales Wrapper-Element: kein <a> als Grid-Item => keine Prose-Link-Regeln */
      .fc2__item {
        margin: 0 !important;
        padding: 0 !important;
      }

      .fc2__card {
        display: flex;
        flex-direction: column;
        text-decoration: none;
        margin: 0;
      }

      .fc2__title,
      .fc2__title *,
      .fc2__link,
      .fc2__link:link,
      .fc2__link:visited,
      .fc2__link:hover,
      .fc2__link:focus {
        font-size: .95rem;
        line-height: 1.3;
        margin: .5rem 0 0;
        display: block;
        overflow: hidden;
        /* >>> Alle Unterstreichungen und Theme-Link-Linien aus */
        text-decoration: none !important;
        background-image: none !important;
        background: none !important;
        box-shadow: none !important;
        border-bottom: 0 !important;
      }

      /* Bild: Höhe = Breite (px-genau via JS), absolut positioniert */
      .fc2__media {
        position: relative;
        width: 100%;
        height: auto;
        border-radius: .5rem;
        overflow: hidden;
        background: #eee;
        box-sizing: border-box;
      }

      .fc2__img {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      /* Textblock: wir gleichen die Höhe per JS an */
      .fc2__meta {
        display: flex;
        flex-direction: column;
        margin: 0;
      }

      /* >>> Fix: Titel darf nie durchgestrichen/unterstrichen sein */
      .fc2__title,
      .fc2__title * {
        font-size: .95rem;
        line-height: 1.3;
        margin: .5rem 0 0;
        display: block;
        overflow: hidden;
        text-decoration: none !important;
        text-decoration-thickness: 0 !important;
      }

      .fc2__price {
        font-weight: 600;
        line-height: 1.3;
        margin: .25rem 0 0;
        display: block;
        overflow: hidden;
      }

      .fc2__btn-wrap {
        text-align: center;
        margin-top: 1rem;
      }

      .fc2__btn-wrap .button {
        margin-left: auto;
        margin-right: auto;
        display: inline-block;
      }
    `;
    document.head.appendChild(style);
  }

  // Bildbox exakt quadratisch (H = W), verhindert Subpixel-Differenzen
  function sizeMedia(grid) {
    grid.querySelectorAll(".fc2__media").forEach(m => {
      const w = Math.round(m.offsetWidth);
      m.style.height = w + "px";
    });
  }

  // gleiche Höhe für Meta (Titel+Preis)
  function equalizeMeta(grid) {
    const metas = Array.from(grid.querySelectorAll(".fc2__meta"));
    metas.forEach(m => (m.style.minHeight = "")); // reset

    if (!window.matchMedia("(min-width: 700px)").matches) return; // nur Desktop

    let max = 0;
    metas.forEach(m => {
      max = Math.max(max, m.getBoundingClientRect().height);
    });
    metas.forEach(m => (m.style.minHeight = Math.ceil(max) + "px"));
  }

  // komplette Kartenhöhen angleichen
  function equalizeCards(grid) {
    const cards = Array.from(grid.querySelectorAll(".fc2__card"));
    cards.forEach(c => (c.style.minHeight = "")); // reset

    if (!window.matchMedia("(min-width: 700px)").matches) return; // nur Desktop

    let max = 0;
    cards.forEach(c => {
      max = Math.max(max, c.getBoundingClientRect().height);
    });
    cards.forEach(c => (c.style.minHeight = Math.ceil(max) + "px"));
  }

  function recalc(grid) {
    sizeMedia(grid);
    equalizeMeta(grid);
    equalizeCards(grid);
  }

  async function init(wrapper) {
    const handle = wrapper.dataset.collectionHandle;
    const limit = parseInt(wrapper.dataset.limit || "8", 10);
    const title = wrapper.dataset.title || "";
    const viewAllText = (wrapper.dataset.viewAllText || "").trim();

    if (!handle) {
      wrapper.outerHTML = "<p>Kein Collection-Handle gesetzt.</p>";
      return;
    }

    buildStylesOnce();
    const fmt = moneyFormatter();

    const shell = document.createElement("div");
    shell.className = "fc2";
    shell.innerHTML = `
      ${title ? `<div class="fc2__header"><h2 class="h2">${title}</h2></div>` : ""}
      <div class="fc2__grid" role="list"></div>
      ${viewAllText ? `<div class="fc2__btn-wrap"><a class="button" href="/collections/${handle}">${viewAllText}</a></div>` : ""}
    `;
    wrapper.replaceWith(shell);

    const grid = shell.querySelector(".fc2__grid");

    try {
      const res = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=${limit}`);
      if (!res.ok) throw new Error("Fehler beim Laden der Produkte");

      const data = await res.json();
      const products = (data && data.products) || [];

      if (products.length === 0) {
        grid.insertAdjacentHTML("beforebegin", `<p>Diese Collection ist leer.</p>`);
        return;
      }

      const svgFallback = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 600'%3E%3Crect width='100%25' height='100%25' fill='%23eee'/%3E%3C/svg%3E";

      const frag = document.createDocumentFragment();

      products.forEach(p => {
        const url = `/products/${p.handle}`;
        const baseImg = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : "";
        const img300 = baseImg ? withWidth(baseImg, 300) : "";
        const img600 = baseImg ? withWidth(baseImg, 600) : "";
        const img900 = baseImg ? withWidth(baseImg, 900) : "";

        const priceRaw = (p.variants && p.variants[0] && p.variants[0].price) || p.price || "";
        const price = priceRaw ? fmt.format(Number(priceRaw)) : "";

        const item = document.createElement("div");
        item.className = "fc2__item";
        item.setAttribute("role", "listitem");

        // **WICHTIG**: Tags korrekt schließen
        item.innerHTML = `
          <div class="fc2__card">
            <a class="fc2__link" href="${url}" aria-label="${(p.title || "").replace(/"/g,'&quot;')}">
              <div class="fc2__media">
                ${baseImg ? `
                  <img class="fc2__img"
                       src="${img600}"
                       srcset="${img300} 300w, ${img600} 600w, ${img900} 900w"
                       sizes="(min-width: 700px) 25vw, 50vw"
                       alt="${(p.title || "").replace(/"/g,'&quot;')}"
                       width="600"
                       height="600"
                       loading="lazy"
                       decoding="async"
                       onerror="this.onerror=null; this.src='${svgFallback}';">
                ` : `
                  <img class="fc2__img"
                       src="${svgFallback}"
                       alt="${(p.title || "").replace(/"/g,'&quot;')}"
                       width="600"
                       height="600">
                `}
              </div>
            </a>
            <div class="fc2__meta">
              <a class="fc2__link" href="${url}">
                <div class="fc2__title">${p.title || ""}</div>
              </a>
              ${price ? `<div class="fc2__price">${price}</div>` : ""}
            </div>
          </div>
        `;

        frag.appendChild(item);
      });

      grid.appendChild(frag);

      const doRecalc = () => requestAnimationFrame(() => recalc(grid));

      // initial
      requestAnimationFrame(() => requestAnimationFrame(doRecalc));

      // Events
      window.addEventListener("resize", doRecalc);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(doRecalc).catch(() => {});
      }

      const ro = new ResizeObserver(doRecalc);
      ro.observe(grid);

      grid.querySelectorAll("img").forEach(img => img.addEventListener("load", doRecalc));

      setTimeout(doRecalc, 400);
      setTimeout(doRecalc, 1200);

    } catch (e) {
      console.error(e);
      shell.insertAdjacentHTML("beforeend", `<p>Die Produkte konnten nicht geladen werden.</p>`);
    }
  }

  function hydrateAll() {
    document.querySelectorAll(".fc2-wrapper").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", hydrateAll);
  } else {
    hydrateAll();
  }

  document.addEventListener("shopify:section:load", hydrateAll);
})();
